import clsx from 'clsx';
import React, { FC, useEffect } from 'react';
import CardSection from './components/CardSection';
import styles from './styles.module.less';
import TableSection from './components/TableSection';
import EarnModal from './components/EarnModal';
import { useUser } from '@auth0/nextjs-auth0';
import EarnInfoSection from 'components/EarnAndStake/EarnInfoSection';
import { useRouter } from 'next/router';
import { useAppSelector, useTypeSafeTranslation } from 'hooks';
import { MAIN_ACCOUNT_KEY, getCurrentSubAccount } from 'store/ducks/sub_account/slice';
import { routes } from 'types/routes';
import { message } from 'antd';

const UltEarnPage: FC = () => {
  const { user } = useUser();
  const router = useRouter();
  const currentSub = useAppSelector(getCurrentSubAccount);
  const { t } = useTypeSafeTranslation();

  const isDisabledStakeAndEarn = currentSub !== MAIN_ACCOUNT_KEY;

  useEffect(() => {
    if (isDisabledStakeAndEarn) {
      if (router.pathname === routes.stake || router.pathname === routes.ultEarn) {
        message.warning(t('stake.error_not_allowed_staking'));
      }
    }
  }, []);
  return (
    <div className={clsx(styles.root, 'container')}>
      <CardSection />
      {user && <EarnInfoSection />}
      <TableSection />
      <EarnModal />
    </div>
  );
};

export default UltEarnPage;
